export var FormStatus = {
    Reset: 'reset',
    Sending: 'sending',
    Failure: 'error',
    Success: 'success' // {response}
};
var FormStore = /** @class */ (function () {
    function FormStore(data) {
        if (data === void 0) { data = {}; }
        this.data = data;
        this.status = { type: 'reset' };
    }
    FormStore.prototype.send = function (xhr) {
        this.status = { type: 'sending', xhr: xhr };
    };
    FormStore.prototype.success = function (response) {
        this.status = { type: 'success', response: response };
        return response;
    };
    FormStore.prototype.fail = function (errors) {
        this.status = { type: 'error', errors: errors };
        return errors;
    };
    FormStore.prototype.reset = function () {
        switch (this.status.type) {
            case 'sending':
                this.status.xhr.abort();
            default:
                this.status = { type: 'reset' };
        }
    };
    FormStore.prototype.setData = function (key, value) {
        this.data[key] = value;
    };
    FormStore.prototype.toString = function () {
        return this.status.type;
    };
    return FormStore;
}());
export { FormStore };
